export const common = {
    phone: {
        type: 'number',
        length: { minimum: 10, maximum: 20 },
        presence: { allowEmpty: false },
    },
    country_code: {
        type: 'number',
        length: { minimum: 1, maximum: 5 },
        presence: { allowEmpty: false },
    },
};
